<template>
  <b-card
    no-body
    class="shadow-body"
  >
    <b-card-header>
      <b-card-title class="mb-1">
        {{ title }}
      </b-card-title>
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <chartjs-component-bar-chart
        :height="400"
        :data="dataset"
        :options="chartjsData.latestBarChart.options"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardTitle,
} from 'bootstrap-vue'
import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    ChartjsComponentBarChart,
  },
  props: {
    yearBarChartData: {
      type: [Object, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
    title: {
      type: [String, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: '',
    },
  },
  data() {
    return {
      chartjsData,
      dataset: {},
    }
  },
  watch: {
    yearBarChartData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$set(this.dataset, 'labels', val.labels)
        this.$set(this.dataset, 'datasets', val.datasets)
      },
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
